<section *ngIf="invoice != undefined" class="invoice mat-elevation-z3">

    <div class="grid">
        <ap-pick-customer (customerChange)="updateCustomer($event)" [customer]="invoice.customer"></ap-pick-customer>

        <div class="invoice-details">
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Invoice number</mat-label>
                    <input matInput placeholder="#" [(ngModel)]="invoice.number">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>P.O/S.O. number</mat-label>
                    <input matInput placeholder="#" [(ngModel)]="invoice.custom">
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Invoice Date</mat-label>
                    <input matInput [matDatepicker]="picker1" [(ngModel)]="invoice.dateCreated">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Due Date</mat-label>
                    <input matInput [matDatepicker]="picker2" [(ngModel)]="invoice.dateDue">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </p>
        </div>
    </div>

    <div class="collection">
        <mat-form-field appearance="fill">
            <mat-label>Contact</mat-label>
            <input [(ngModel)]="invoice.additionalData.contact" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Contact Number</mat-label>
            <input [(ngModel)]="invoice.additionalData.contactNumber" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Collection Address</mat-label>
            <input [(ngModel)]="invoice.additionalData.collectionAddress" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Quantity</mat-label>
            <input [(ngModel)]="invoice.additionalData.quantity" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Data destruction</mat-label>
            <input [(ngModel)]="invoice.additionalData.dataDestruction" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Collection Hours</mat-label>
            <input [(ngModel)]="invoice.additionalData.collectionHours" matInput>
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Notes</mat-label>
            <input [(ngModel)]="invoice.additionalData.notes" matInput>
        </mat-form-field>
    </div>

    <div class="invoice-items">

        <table mat-table [dataSource]="invoiceItemsDataSource">

            <ng-container matColumnDef="item">
                <th mat-header-cell *matHeaderCellDef> Item </th>
                <td apStatus="Item code" mat-cell class="item-cell" *matCellDef="let element">
                    <div class="input-group">
                        <input matInput [value]="element.item" [(ngModel)]="element.item">
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="desc">
                <th mat-header-cell *matHeaderCellDef> Description </th>
                <td mat-cell *matCellDef="let element">
                    <textarea [(ngModel)]="element.desc" class="description" matInput cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1">{{element.desc}}</textarea>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef> Price</th>
                <td mat-cell class="price-cell" *matCellDef="let element">
                    <ap-money class="amountInput" [(amount)]="element.price"></ap-money>
                </td>
                <td class="invoiceTotal" mat-footer-cell *matFooterCellDef>{{invoice.total | human}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell class="price-cell" *matCellDef="let element;let i = index">
                    <button (click)="deleteLineItem(i)" mat-icon-button>
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

        </table>


        <div class="add-line-item">
            <button mat-button (click)="addLineItem()">Add line item</button>
        </div>

        <div class="invoice-actions">
            <button (click)="save()" mat-raised-button color="primary">Save</button><br>
        </div>

    </div>

</section>